import type { Places } from '~/types/places';

const PLACES_PROFILE: Places = {
  business: {
    bank: -15,
    government: -15,
    office: -15,
  },
  education: {
    childcare: -15,
    high_school: -10,
    library: -5,
    primary: -10,
    university: -5,
  },
  essentials: {
    electricity: 10,
    gas: 10,
    sewers: 5,
    waste: 5,
    water: 10,
  },
  food: {
    bakery: 10,
    coffee: 10,
    fast_food: 12,
    restaurant: 15,
  },
  health: {
    clinic: 5,
    dentist: -5,
    hospital: -5,
    pharmacy: 5,
  },
  nature: {
    beach: 10,
    forest: 12,
    lake: 15,
    mountain: 10,
    park: 12,
    river: 10,
  },
  religion: {
    church: -5,
    mosque: -5,
  },
  shops: {
    grocery: 8,
    mall: 15,
  },
  soil: {
    clay: -5,
    loam: 0,
    peat: -10,
    salt: -15,
    sand: 15,
    silt: 0,
  },
  sport: {
    gym: 10,
    pool: 10,
  },
  telecom: {
    cable_tv: 15,
    fiber_optic: 15,
    network_4g: 10,
    network_5g: 10,
    phone: 15,
  },
  transport: {
    airport: 5,
    bus: 5,
    ferry: 10,
    gas_station: 5,
    metro: 10,
    parking: 10,
    taxi: 12,
    train: 10,
    tram: 7,
  },
};

export default PLACES_PROFILE;
